import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const CompanyContext = createContext(null);

export const CompanyProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");

  const loadCompanies = async () => {
    try {
      const { data } = await api.get("/companies");
      setCompanies(data);
    } catch {}
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  return (
    <CompanyContext.Provider
      value={{ companies, selectedCompany, setSelectedCompany, loadCompanies }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);
